module.exports = __webpack_public_path__ + "img/62.f8c35e73.png";